import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { useEnterpriseNavigate } from '@mews-commander/ui';
import { LedgerActivityReportUrlSearchValues } from '../schema';

interface useLedgerActivityReportExportMutationProps {
    filterValues: LedgerActivityReportUrlSearchValues;
}
export const useLedgerActivityReportExportMutation = ({ filterValues }: useLedgerActivityReportExportMutationProps) => {
    const navigate = useEnterpriseNavigate();
    const { startDate, endDate, ownerId } = filterValues;
    return useRepositoryMutation('ledgerActivityReport', 'export', {
        transformParams: ({ format }) => ({
            startDate,
            endDate,
            ownerId,
            format,
        }),
        onSuccess: () => {
            showSuccessAlert({
                description: lt('LedgerActivityReportExportSuccessful'),
                action: {
                    text: lt('LedgerActivityReportExportDetailsRedirect'),
                    onClick: () => {
                        void navigate({
                            to: 'Export/Index',
                        });
                    },
                },
            });
        },
    });
};
